import { Injectable } from "@nestjs/common";
import { AssetsPo } from "../assets-po-entity";
import { AssetsPoDtO } from "./assets-po-dto";








@Injectable()
export class AssetsPoAdapter {


    public convertDtoToEntity(AssetsPoDTO: AssetsPoDtO, currentFinancialYear: string, isUpdate: boolean = false): AssetsPo {
        const purchaseOrder = new AssetsPo();


        purchaseOrder.saleOrderId = AssetsPoDTO.saleOrderId;

        purchaseOrder.purchaseOrderDate = AssetsPoDTO.purchaseOrderDate;
        purchaseOrder.vendorName = AssetsPoDTO.vendorId;
        purchaseOrder.paymentTerms = AssetsPoDTO.paymentTerms;
        purchaseOrder.expectedDeliveryDate = AssetsPoDTO.expectedDeliveryDate;
        purchaseOrder.note = AssetsPoDTO.note;
        purchaseOrder.remarks = AssetsPoDTO.remarks;
        purchaseOrder.deliveryAddress = AssetsPoDTO.deliveryAddress;
        purchaseOrder.billingAddress = AssetsPoDTO.billingAddress;
        purchaseOrder.exchangeRate = AssetsPoDTO.exchangeRate;
        purchaseOrder.totalTransportation = AssetsPoDTO.transportation;
        purchaseOrder.poType = AssetsPoDTO.poType;
        purchaseOrder.unitId = AssetsPoDTO.unitId;
        if (AssetsPoDTO.purchaseOrderId) {
            purchaseOrder.updatedUser = AssetsPoDTO.updatedUser;
            purchaseOrder.purchaseOrderId = AssetsPoDTO.purchaseOrderId;
        } else {
            purchaseOrder.createdUser = AssetsPoDTO.createdUser;
            purchaseOrder.poNumber = currentFinancialYear;
        }

        return purchaseOrder;
    }
    public convertEntityToDto(purchaseOrderObject: AssetsPo): AssetsPoDtO {
        const assetsPoDTO = new AssetsPoDtO;
        assetsPoDTO.purchaseOrderId = purchaseOrderObject.purchaseOrderId;
        assetsPoDTO.saleOrderId = purchaseOrderObject.saleOrderId;
        assetsPoDTO.purchaseOrderDate = purchaseOrderObject.purchaseOrderDate;
        assetsPoDTO.vendorId = purchaseOrderObject.vendorName;
        assetsPoDTO.poNumber = purchaseOrderObject.poNumber;
        assetsPoDTO.transportation = purchaseOrderObject.totalTransportation;
        assetsPoDTO.paymentTerms = purchaseOrderObject.paymentTerms;
        assetsPoDTO.expectedDeliveryDate = purchaseOrderObject.expectedDeliveryDate;
        assetsPoDTO.note = purchaseOrderObject.note;
        assetsPoDTO.remarks = purchaseOrderObject.remarks;
        assetsPoDTO.deliveryAddress = purchaseOrderObject.deliveryAddress;
        assetsPoDTO.createdUser = purchaseOrderObject.createdUser;
        assetsPoDTO.updatedUser = purchaseOrderObject.updatedUser;
        return assetsPoDTO;
    }
}
